﻿import { fetchBaseQueryWrapper } from "@/services/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";

export const milestoneTemplateApi = createApi({
  reducerPath: "milestoneTemplateApi",
  baseQuery: fetchBaseQueryWrapper({
    path: "admin/milestone-templates",
  }),
  endpoints: (build) => ({
    searchMilestoneTemplatesByProperties: build.query({
      query: ({ property, value } = {}) =>
        `searchByProperties/${property}/${value}`,
      transformResponse: ({ data }) => data,
    }),
  }),
});

export const { useSearchMilestoneTemplatesByPropertiesQuery } =
  milestoneTemplateApi;
